import { useContext, useState } from "react";
import { LoginContext } from "./LoginProvider";

// ============================|| FIREBASE - LOGIN ||============================ //

const AuthLogin = () => {
  const loginContext = useContext(LoginContext);
  const [id, setId] = useState("");
  const [password, setPassword] = useState("");

  const onSubmit = () => {
    console.log(id, password);
    loginContext.login(0, id, password).then(({result, response}) => {
      console.log(result, response);
      alert(result);
    });
  };

  return (
    <>
      아이디
      <input type="text" onChange={(e) => setId(e.target.value)} />
      비밀번호
      <input type="password" onChange={(e) => setPassword(e.target.value)} />
      <input type="button" value="로그인" onClick={() => onSubmit()} />
    </>
  );
};

export default AuthLogin;
